// © 2015-2021 WDNA - All Rights Reserved

import _ from 'lodash';
import * as React from 'react';

import Select2, { DataSelect2 } from 'wdna-select2';

import { TypeSensorVariableDO } from '../../../../configuration/requests';
import { SensorAdjustmentDO, SensorDO } from '../../../requests';

interface Props {
  formValues: {
    doSensor?: SensorDO;
    typeVariableArray: TypeSensorVariableDO[];
    data: Partial<SensorAdjustmentDO>;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function Form(props: Props): JSX.Element {
  const { formValues, onChange } = props;
  const { data, typeVariableArray, doSensor } = formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Device</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.sensorName"
            name="data.sensorName"
            value={_.defaultTo(doSensor?.name, '')}
            className="input-new"
            style={{ width: '80%' }}
            placeholder="Device"
            readOnly
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Formula</b> - Write DX to use the chosen variable in the formula.
          </label>
          &nbsp;
          <input
            type="text"
            id="data.formula"
            name="data.formula"
            value={_.defaultTo(data.formula, '')}
            onChange={onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Formula"
            required
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Variable Type</b> &nbsp;
          </label>
          <span className="mandatory">
            <Select2
              id="data.typeSensorVariableId"
              name="data.typeSensorVariableId"
              value={_.defaultTo(data?.typeSensorVariableId, '')}
              onChange={onChange}
              data-ctype="number"
              data={typeVariableArray.map((item: TypeSensorVariableDO): DataSelect2 => {
                return { text: `${item.order}: ${item.variableName}`, id: item.id };
              })}
              options={{ placeholder: 'Select option' }}
              style={{ width: '80%' }}
              required
            />
          </span>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Comments</b> - Available characters: {255 - ((data.comments && data.comments.length) || 0)}
          </label>
          <textarea
            id="data.comments"
            name="data.comments"
            value={_.defaultTo(data.comments, '')}
            onChange={onChange}
            className="input-new"
            style={{ width: '80%' }}
            maxLength={255}
            rows={5}
            cols={55}
          />
        </div>
      </div>
    </fieldset>
  );
}
